import React, { useEffect, useState } from "react";
import DetailsDescription from "./sections/mainDescription";
import DetailsTabs from "./sections/tabbing";
import { useParams } from "react-router-dom";
import DiscriptionTab from "./sections/tabs/Description";
import SpecsTab from "./sections/tabs/Specifications";
import ClinicalSegmintTab from "./sections/tabs/ClinicalSegment";
import Documents from "./sections/tabs/Documents";
import { getProduct } from "../../../api/Products";
import useRequest from "../../../hooks/useRequest";
import LoadingSpinner from "../../../components/LoadingSpinner";

const ProductsDetails = () => {
  const [ProductsDetails, setProductsDetails] = useState();
  const [Loading, setLoading] = useState(true);
  const {data_,loading_,requestApi} = useRequest()
  
  // paramters here
  const { id } = useParams();

  useEffect(() => {
    setLoading(true);
    const fetchProducts = async () => {
       await requestApi(`/product/${id}`,{method:"GET"});
      console.log(data_)
    };

    fetchProducts();
  }, []);



  const Tabs = loading_ ? [] : [
    {
      id: "Description",
      label: "Description",
      href: "#",
      content: (
        <DiscriptionTab
          Descripe={data_?.description?.describe}
          benefits={data_?.description?.benefits}
        />
      ),
    },
    ...(data_?.specifications && data_.specifications.length > 0 && data_.specifications[1].specs && data_.specifications[1].specs.length > 0 ? [{
      id: "Specifications",
      label: "Specifications",
      href: "#",
      content: (
        <SpecsTab
          mainSpec={data_?.specifications[0].mainSpec}
          Options={data_?.specifications[1].specs}
        />
      ),
    }] : []),
    {
      id: "Clinical Segment",
      label: "Clinical Segment",
      href: "#",
      content: (
        <ClinicalSegmintTab
          Segments={data_?.clinicalSegments.segments}
          FieldApplication={data_?.clinicalSegments.fieldOfApplication}
        />
      ),
    },
    {
      id: "Documents",
      label: "Documents",
      href: "#",
      content: <Documents Documents={data_?.document} />,
    },
  ];
  


  
  return (
    <div className="App-header bg-[#F4F7F7]">
      {loading_ ? (
        <><LoadingSpinner/></>
      ) : (
        <>
        <DetailsDescription
          images={ data_?.images[0].url ? data_?.images.map((img) => (img.url))  : data_?.images   || []}
          name={data_?.name}
          Features={data_?.feature}
          subname={data_?.subName}
        />
        {/* <p onClick={()=>{console.log(data_?.specifications)}}>test</p> */}
      <DetailsTabs tabs={Tabs} />
      </>
      )}
      {/* <a onClick={()=>{console.log()}}>sale</a> */}
    </div>
  );
};

export default ProductsDetails;
